import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import createNetworkReducers, { NetworkState } from '../create-network-reducer';
import { FormFieldsData, ReasonsType } from '../../../types/form.types';

export interface FormFieldsState extends NetworkState {
  reasons: ReasonsType;
  fields: FormFieldsData;
  fieldsValues: { [key: string]: { value: string; faq_tag?: string } };
  redirectedFromClients: string;
}

const createInitialFormFieldsState = (): FormFieldsState => ({
  reasons: {},
  fields: {},
  fieldsValues: {},
  redirectedFromClients: '',
  isLoading: false
});

const fieldFormSlice = createSlice({
  name: 'formFields',
  initialState: createInitialFormFieldsState(),
  reducers: {
    setReasons(
      state: FormFieldsState,
      action: PayloadAction<ReasonsType>
    ): void {
      state.reasons = action.payload;
    },
    setField(
      state: FormFieldsState,
      action: PayloadAction<FormFieldsData>
    ): void {
      state.fields = action.payload;
    },
    setFieldValue(
      state: FormFieldsState,
      action: PayloadAction<{
        fieldName: string;
        value: string;
        faq_tag?: string;
      }>
    ): void {
      state.fieldsValues[action.payload.fieldName] = {
        value: action.payload.value,
        faq_tag: action.payload.faq_tag
      };
    },
    resetFieldValue(
      state: FormFieldsState,
      action: PayloadAction<string>
    ): void {
      delete state.fieldsValues[action.payload];
    },
    resetAllFieldsValues(state: FormFieldsState): void {
      state.fieldsValues = {};
    },
    setRedirectedFromClients(
      state: FormFieldsState,
      action: PayloadAction<string>
    ): void {
      state.redirectedFromClients = action.payload;
    },
    // NETWORK
    ...createNetworkReducers()
  }
});

const { actions, reducer: formFieldsReducer } = fieldFormSlice;

export { createInitialFormFieldsState };
export const {
  setReasons,
  setField,
  setFieldValue,
  resetFieldValue,
  resetAllFieldsValues,
  setRedirectedFromClients,
  fetchRequest: fetchFormFieldsRequest,
  fetchSuccess: fetchFormFieldsSuccess,
  fetchError: fetchFormFieldsError
} = actions;
export default formFieldsReducer;
